import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    padding: "20px",
    backgroundColor: theme.kooee.backgrounds.secondary,
    color: theme.kooee.titles.primary
  },
  title: {
    flexGrow: 1
  },
  logo: {
    flexGrow: 1,
    width: "20vmin",
    height: "10vmin"
  },
  menuButton: {
    flexGrow: 0
  },
  divider: {
    width: " 3vw",
    marginTop: "0.2rem"
  }
}));
